module.exports = __webpack_public_path__ + "assets/b1c5807c9050311e9ef2edce4dc3d2c8.mp3";